import React from "react";
import { Link } from "react-router-dom";

/**
 * Reusable page hero with cinematic image, overlay, headline & subtitle.
 */
export default function PageHero({ eyebrow, title, subtitle, image, height = "h-[70vh]" }) {
    return (
        <section className={`relative ${height} min-h-[480px] w-full overflow-hidden`} data-testid="page-hero">
            <div className="absolute inset-0 overflow-hidden">
                <img
                    src={image}
                    alt=""
                    className="w-full h-full object-cover animate-ken-burns"
                    loading="eager"
                />
                <div className="absolute inset-0 bg-navy/55" />
                <div className="absolute inset-0 bg-gradient-to-b from-navy/30 via-transparent to-navy/40" />
            </div>
            <div className="relative h-full container-luxe flex flex-col justify-end pb-20 sm:pb-24">
                <p className="overline text-gold/90 mb-5 animate-fade-up" style={{ animationDelay: "0.2s" }}>{eyebrow}</p>
                <h1
                    className="font-serif text-pearl text-5xl sm:text-6xl lg:text-7xl leading-[1.05] max-w-4xl tracking-tight animate-fade-up"
                    style={{ animationDelay: "0.45s" }}
                >
                    {title}
                </h1>
                {subtitle && (
                    <p
                        className="mt-6 text-pearl/80 text-base sm:text-lg max-w-2xl leading-relaxed animate-fade-up"
                        style={{ animationDelay: "0.7s" }}
                    >
                        {subtitle}
                    </p>
                )}
            </div>
        </section>
    );
}
